/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type AutocompleteParams = {
/**
 * @maxLength 200
 */
prefix?: string;
/**
 * @minimum 1
 * @maximum 200
 */
limit?: number;
pool_ids?: string[] | null;
};
